import { styled, css, Box, BoxProps } from '@mui/material'
import { getFlexValue, getUnitValue } from '../../../utils/processStyles'
import Text, { TextProps } from '../Text'
import {
  PromotionLabelStylesProps,
  PromotionTextStyle
} from './PromotionLabel.types'
import Icon from '../Icon'
import Button from '../Button'

export const PromotionLabelWrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    !['lineHeightAuto', 'wrap'].includes(String(prop))
})<PromotionLabelStylesProps & BoxProps>(
  ({ align, justify, size, gap, type, wrap }) => css`
    display: flex;
    align-items: ${getFlexValue(align)};
    justify-content: ${getFlexValue(justify)};
    font-size: ${getUnitValue(size)};
    gap: ${getUnitValue(gap)};

    ${type === 'tag' &&
    css`
      width: 100%;
      flex-wrap: ${wrap ? 'wrap' : 'nowrap'};
      overflow: hidden;
      justify-content: center;
      text-align: center;
      gap: 0 4px;
      padding: 2px 8px;
    `}

    ${type === 'detail-extended' &&
    css`
      width: 100%;
      gap: 0 8px;
      padding: 6px 10px;
      justify-content: space-between;
    `}
  `
)
PromotionLabelWrapper.defaultProps = {
  size: '1em',
  fontWeight: 700,
  align: 'end',
  justify: 'start',
  gap: 4
}

export const IconWrapper = styled(Icon)(
  ({ theme, color, size }) => css`
    color: ${color || theme.palette.primary.main};
    min-width: ${size}px;
    min-height: ${size}px;
  `
)

export const PromotionTextWrapper = styled(Box)<
  PromotionLabelStylesProps & BoxProps
>(
  ({ type }) => css`
    display: flex;
    flex-direction: column;
    ${type === 'detail-extended' &&
    css`
      text-align: left;
      width: 100%;
    `}
  `
)

export const PromotionTitle = styled(Text)<TextProps>(
  () => css`
    color: inherit;
    font-weight: 600;
    font-size: 14px;
  `
)

export const ShortcutButton = styled(Button)(
  () => css`
    min-width: 88px;
  `
)

export const PromotionText = styled(Text)<PromotionTextStyle & TextProps>(
  ({ type, theme }) => css`
    ${type === 'detail' &&
    css`
      color: inherit;
      max-width: 480px;
      word-break: break-word;
    `}
    ${type === 'label' &&
    css`
      font-weight: 600;
    `}
    ${type === 'tag' &&
    css`
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: inherit;
      flex-grow: 1;
      min-width: 20px;
    `}
    ${type === 'detail-extended' &&
    css`
      color: ${theme.palette.text.secondary};
    `}
  `
)

export const SecondaryText = styled(Text)<
  Partial<PromotionTextStyle & TextProps>
>(
  () => css`
    font-weight: 700;
    white-space: nowrap;
    color: inherit;
  `
)
